import React from "react";
import { BookOpenIcon, GiftIcon, CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { offerIncludes } from "../../data/content";
import { images } from "../../data/links";
const stack = [{
  icon: BookOpenIcon,
  title: "The ClinCheck Blueprint™ — 6-Volume Collection",
  text: "Clinical assessment, space management, attachments, complex cases, biomechanics, and treatment finishing.",
  value: "$97"
}, {
  icon: GiftIcon,
  title: "The 5 Professional Bonus Resources",
  text: "Communication, pre-approval review, documentation, progress tracking, and patient education.",
  value: "$167"
}];
export function OfferSection() {
  return <section id="offer" className="bg-ink px-4 py-16 sm:py-24" data-id="element-241" data-mp="3ixjx36t4ntwz">
      <div className="mx-auto max-w-3xl" data-id="element-242" data-mp="3ex04mgji1eh6">
        <div className="text-center" data-id="element-243" data-mp="3eyb5o8lk884l">
          <p className="mx-auto w-fit rounded-full bg-alert px-4 py-2 text-sm font-black uppercase text-white" data-id="element-244" data-mp="3ezdved75c4ix">
            Special launch offer
          </p>
          <h2 className="mt-4 text-balance font-display text-[30px] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-245" data-mp="1fjip4u6ehpmi">
            Everything you need to organize your ClinCheck review process
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-[28px] bg-white shadow-2xl ring-4 ring-cta" data-id="element-246" data-mp="15t7b2et0601w">
          <div className="bg-cta px-4 py-3 text-center text-sm font-black uppercase text-ink" data-id="element-247" data-mp="1tjbdwjyd9vru">
            Here's everything included today
          </div>
          <div className="p-5 sm:p-10" data-id="element-248" data-mp="1kilhpf5723dl">
            <img src={images.hero} alt="Complete ClinCheck Blueprint package" className="mx-auto w-full max-w-md" data-id="element-249" data-mp="1khk3j1svt0rn" />

            <ul className="mt-6 divide-y divide-navy/10" data-id="element-250" data-mp="1ol9tnvp7fqes">
              {stack.map(({
              icon: Icon,
              title,
              text,
              value
            }) => <li key={title} className="flex gap-4 py-4" data-id="element-251" data-mp="d4rw1s9vfhqk">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy" data-id="element-252" data-mp="d25r80ed7gc1">
                    <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-253" data-mp="2fsrws3ewk35g" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-254" data-mp="261482a9qd07o">
                    <div className="flex items-start justify-between gap-3" data-id="element-255" data-mp="25zt3i88gnofi">
                      <h3 className="text-base font-extrabold leading-snug text-navy sm:text-lg" data-id="element-256" data-mp="212sz01r9etqi">{title}</h3>
                      <span className="shrink-0 font-bold text-navy/50 line-through" data-id="element-257" data-mp="1x1h4bhtj3ibg">{value}</span>
                    </div>
                    <p className="mt-1 text-sm leading-relaxed text-navy/70" data-id="element-258" data-mp="1rzrv87pv9eq0">{text}</p>
                  </div>
                </li>)}
            </ul>

            <div className="mt-4 rounded-2xl bg-paper p-5 text-center" data-id="element-259" data-mp="1i3yjurnvvr9t">
              <p className="text-base font-bold text-navy/70" data-id="element-260" data-mp="3hgao9b2p42mb">
                Total reference value: <span className="line-through" data-id="element-261" data-mp="3hdwvx9zeh4ig">$264</span>
              </p>
              <p className="mt-2 text-sm font-extrabold uppercase text-navy" data-id="element-262" data-mp="3chzgr6zvi479">Today, get everything for just</p>
              <p className="font-display text-7xl font-extrabold leading-none text-ctadark sm:text-8xl" data-id="element-263" data-mp="3kw46gnhwit62">$27</p>
              <p className="mt-1 text-sm font-bold uppercase text-navy/70" data-id="element-264" data-mp="3oxfnw5qmg836">USD · One-time payment</p>
              <p className="mt-3 flex items-center justify-center gap-2 text-sm font-semibold text-[#0A7FBF]" data-id="element-265" data-mp="3tsv06t8zdvxh">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-266" data-mp="31zchbxfohju3" />
                Currency is converted automatically to your local currency
              </p>
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-267" data-mp="362r55a9uz4i3">
              {offerIncludes.map(i => <li key={i} className="flex items-center gap-2.5 text-[15px] font-semibold text-navy" data-id="element-268" data-mp="3fz40ecl1xqey">
                  <CheckIcon className="h-5 w-5 shrink-0 text-ctadark" strokeWidth={3} aria-hidden="true" data-id="element-269" data-mp="qa1zvi57r3l9" />
                  {i}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-270" data-mp="vapqi2pj5iey">
              <CTAButton label="Yes, I want it — $27" sublabel="Instant digital access · 7-day guarantee" data-id="element-271" data-mp="2451nuka22a4z" />
            </div>

            <Countdown tone="light" data-id="element-272" data-mp="1z81qcxr9ufph" />
            <ScarcityBar data-id="element-273" data-mp="1z935pefblod0" />

            <p className="mt-5 flex items-center justify-center gap-2 text-xs font-semibold text-navy/60" data-id="element-274" data-mp="2d717zlgd9uc5">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-275" data-mp="2875be7a0156m" />
              Secure checkout · Instant download · No recurring fees
            </p>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-white/70" data-id="element-276" data-mp="2i5untkj4lxfh">
          No lengthy course to complete. No complicated software to learn. Just practical resources designed for
          professional reference.
        </p>
      </div>
    </section>;
}